import GoodPracticeListTable from "./components/GoodPracticeListTable";

export default GoodPracticeListTable